<template>
    <section id="testimonials" class="bg-gray-50/60 py-16 sm:py-24">
        <Container>
            <SectionHeading eyebrow="Testimonials" title="What people are saying" />

            <div class="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-6 sm:mt-16 lg:max-w-none lg:grid-cols-3">
                <figure v-for="testimonial in testimonials" :key="testimonial.id"
                    class="flex flex-col rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-900/5">
                    <svg class="size-8 text-accent-300" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
                        <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4Zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4Z" />
                    </svg>
                    <blockquote class="mt-4 flex-1 text-base/7 text-gray-700">
                        {{ testimonial.testimonial }}
                    </blockquote>
                    <figcaption class="mt-6 flex items-center gap-x-3 border-t border-gray-100 pt-6">
                        <img class="size-10 rounded-full bg-gray-100 object-cover" src="/images/default-avatar.png" alt="" />
                        <div class="text-sm font-semibold text-gray-900">{{ testimonial.name }}</div>
                    </figcaption>
                </figure>
            </div>
        </Container>
    </section>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import Container from '@/components/ui/Container.vue';
import SectionHeading from '@/components/ui/SectionHeading.vue';

const testimonials = ref([]);

onMounted(async () => {
    const response = await axios.get('/api/testimonials');
    testimonials.value = response.data.data;
});
</script>
